<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    label: string;
    desc?: string;
    icon?: string; // iconify icon
    isLink?: boolean;
    isOutLink?: boolean;
    rightLabel?: string;
    value?: string | boolean;
    isCheckbox?: boolean;
    checked?: boolean;
  }>(),
  {}
);

const emit = defineEmits<{
  (e: "update:checked", val: boolean): void;
}>();
</script>
<template>
  <div
    class="flex justify-between cursor-pointer p-4 items-center hover:bg-base-300"
    @click="isCheckbox && emit('update:checked', !checked)"
  >
    <div
      :class="{
        'opacity-50': isCheckbox && !checked,
      }"
      class="flex gap-2 items-center"
    >
      <i v-if="icon" :class="`${icon}`" class="iconify" />
      <div class="flex flex-col">
        <span>{{ label }}</span>
        <span v-if="desc" class="text-base-content/50">{{ desc }}</span>
      </div>
    </div>
    <i
      v-if="isLink"
      class="iconify mingcute--right-line text-base-content/50"
    />
    <i
      v-else-if="isOutLink"
      class="iconify mingcute--external-link-line text-base-content/50"
    />
    <span v-else-if="rightLabel" class="text-base-content/50">{{
      rightLabel
    }}</span>
    <van-checkbox
      v-else-if="isCheckbox"
      :model-value="checked"
      @update:model-value="emit('update:checked', $event)"
    />
    <template v-else>
      <slot />
    </template>
  </div>
</template>
